<mat-dialog-content>
  <div class="message">{{ data.success ? ("forgetPassword.resendSuccess" | translate) : ("forgetPassword.resendError" | translate) }}</div>

  <div class="actions-container">
    <button class="outline-button" mat-ripple (click)="ok()">
      {{ "common.ok" | translate }}
    </button>
  </div>
</mat-dialog-content>
